import React from "react";
import { AiOutlineArrowDown } from "@react-icons/all-files/ai/AiOutlineArrowDown";
import { AiOutlineArrowUp } from "@react-icons/all-files/ai/AiOutlineArrowUp";
import { IoIosCopy } from "@react-icons/all-files/io/IoIosCopy";
import { IoIosRemove } from "@react-icons/all-files/io/IoIosRemove";
import { TranslatableString, } from "@rjsf/utils";
import clsx from "clsx";
import Button from "./Button";
export default function IconButton(props) {
    const { icon, iconType, className, uiSchema, registry, disabled, ...otherProps } = props;
    return (React.createElement(Button, { size: "xs", className: clsx("rounded-none first-of-type:rounded-l-lg last-of-type:rounded-r-lg", { "w-full": iconType === "block" }, { "cursor-not-allowed opacity-50": disabled }, className), ...otherProps }, icon));
}
export function CopyButton(props) {
    const { registry: { translateString }, } = props;
    return (React.createElement(IconButton, { title: translateString(TranslatableString.CopyButton), ...props, icon: React.createElement(IoIosCopy, null) }));
}
export function MoveDownButton(props) {
    const { registry: { translateString }, } = props;
    return (React.createElement(IconButton, { title: translateString(TranslatableString.MoveDownButton), ...props, icon: React.createElement(AiOutlineArrowDown, null) }));
}
export function MoveUpButton(props) {
    const { registry: { translateString }, } = props;
    return (React.createElement(IconButton, { title: translateString(TranslatableString.MoveUpButton), ...props, icon: React.createElement(AiOutlineArrowUp, null) }));
}
export function RemoveButton(props) {
    const { registry: { translateString }, } = props;
    return (React.createElement(IconButton, { title: translateString(TranslatableString.RemoveButton), ...props, variant: "red", icon: React.createElement(IoIosRemove, null) }));
}
//# sourceMappingURL=IconButton.js.map